/*
 * Copyright (c) 2026 Paxia AI Pty Ltd. All rights reserved.
 * This software is proprietary and confidential.
 * No part of this codebase may be copied, modified, published, distributed, sublicensed, or used without prior written permission from Paxia AI Pty Ltd.
 */

import api from "./api";

// ── Gateways ─────────────────────────────────────────────────────────────
/** List available payment gateways (Stripe, PayPal, etc.). */
export const getGateways = () =>
  api.get("/payments/gateways/");

// ── Create Payment ───────────────────────────────────────────────────────
/**
 * Create a new payment intent.
 * @param {{ gateway: string, amount: number, currency?: string, description?: string, reference_type?: string, reference_id?: string, success_url?: string, cancel_url?: string, metadata?: object }} data
 */
export const createPayment = (data) =>
  api.post("/payments/create/", data);

// ── Confirm Payment ──────────────────────────────────────────────────────
/** Confirm a pending payment after client-side completion. */
export const confirmPayment = (intentId) =>
  api.post("/payments/confirm/", { intent_id: intentId });

// ── Payment Intents ──────────────────────────────────────────────────────
/**
 * List the current user's payment intents with optional filters.
 * @param {{ status?: string, reference_type?: string, limit?: number, offset?: number }} params
 */
export const listPaymentIntents = (params = {}) =>
  api.get("/payments/intents/", { params });

/** Get full detail of a single payment intent. */
export const getPaymentIntent = (intentId) =>
  api.get(`/payments/intents/${intentId}/`);

// ── Payment Methods ──────────────────────────────────────────────────────
/** List saved payment methods. */
export const listPaymentMethods = () =>
  api.get("/payments/methods/");

/**
 * Save a new payment method.
 * @param {{ gateway: string, gateway_token: string, method_type?: string, label?: string, last4?: string, brand?: string, expiry_month?: number, expiry_year?: number, is_default?: boolean }} data
 */
export const createPaymentMethod = (data) =>
  api.post("/payments/methods/", data);

/** Soft-delete a payment method. */
export const deletePaymentMethod = (id) =>
  api.delete(`/payments/methods/${id}/`);

/** Set a payment method as default. */
export const setDefaultPaymentMethod = (id) =>
  api.post(`/payments/methods/${id}/set-default/`);
